export const isPaymentMethodFailed = (paymentMethod) => paymentMethod.status === 'FAILED' ||
    (paymentMethod.details.type === 'CARD' && paymentMethod.details.expired);
